import { useSnapshot } from 'valtio'
import uiState from '../data'
import { AnimatePresence, motion } from 'framer-motion'
import { useState } from 'react'
import { windowSizeState } from '../utils/windowSize'

const Homepage = ({ event }) => {
  const { visible, animationSrc } = useSnapshot(uiState[event])
  const [isHover, setIsHover] = useState(false)
  const { mobileMode } = useSnapshot(windowSizeState)
  const [sunAnimation, setSunAnimation] = useState(false)

  const enterInfoPage = () => {
    setSunAnimation(true)
    setTimeout(() => {
      uiState.letterPage.visible = true
      uiState[event].visible = false
    }, 2000)
  }

  const opacityVariants = {
    show: {
      opacity: [0.2, 0.4, 0.6, 0.8, 1, 0.8, 0.6, 0.4, 0.2],
      transition: {
        duration: 2.5,
        repeat: Infinity,
        ease: 'linear'
      },
      willChange: 'transform',
      layout: 'position'
    },
    hide: {
      opacity: [0]
    }
  }

  return (
    <>
      <AnimatePresence>
        {visible && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: sunAnimation ? 1.8 : 0.8 }}
            className='screen-setting overflow-hidden fixed top-0 left-0'
          >
            <div className=' absolute top-[8%] right-[24%]  w-[9%] smallLaptop:w-[10%] smallLaptop:top-[10%] landscapePad:top-[18%] landscapePad:right-[22%] landscapePad:w-[11%] portraitPad:h-[40%] portraitPad:w-auto portraitPad:right-[8%] portraitPad:top-[15%] landscapePhone:w-[7%]'>
              <img
                src='../startMedia/zh_title.png'
                alt='中文標題'
                className='w-full object-contain portraitPad:h-full portraitPad:w-auto '
              />
            </div>
            <div className=' absolute top-[20%] left-[14%]  w-[18%] laptop:top-[15%] laptop:w-[17%] smallLaptop:w-[14%]  smallLaptop:top-[28%] landscapePad:top-[34%] landscapePad:w-[20%] portraitPad:w-[40%] portraitPad:left-[8%] portraitPad:top-[35%] landscapePhone:w-[15%] landscapePhone:top-[10%]'>
              <img
                src='../startMedia/en_title.png'
                alt='英文標題'
                className='w-full object-contain'
              />
            </div>
            <div className=' absolute left-0 bottom-0 translate-y-[15%] w-full landscapePad:translate-y-0 portraitPad:translate-y-0 portraitPad:h-[35vh]'>
              <img
                src='../startMedia/sea_bg.png'
                alt='海'
                className=' w-full portraitPad:h-full'
              />

              <img
                src='../startMedia/island.png'
                alt='島'
                className=' absolute top-0 left-1/2 -translate-x-1/2 w-[90%] -translate-y-[53%] object-contain portraitPad:w-full '
              />
              <motion.div
                className=' absolute top-0 left-[48%] w-[200px]  z-50'
                animate={{ scale: sunAnimation ? 60 : 1, x: '-50%', y: '-75%' }}
                transition={{ duration: sunAnimation ? 3 : 0, delay: 0.5 }}
              >
                <img
                  src='../startMedia/sun.png'
                  alt='太陽'
                  className='w-full z-50'
                />
              </motion.div>
            </div>
            {mobileMode ? (
              <motion.div
                className='w-full h-[35%] absolute bottom-0 left-1/2  flex justify-center '
                animate={{
                  opacity: sunAnimation ? 0 : 1,
                  x: '-50%',
                  y: mobileMode ? '-5%' : 0
                }}
                transition={{ duration: sunAnimation ? 1 : 0 }}
              >
                <img
                  src='../startMedia/wave_phone.png'
                  alt='海浪'
                  className='w-full object-cover'
                />
              </motion.div>
            ) : (
              <motion.div
                className='w-full h-full absolute top-0 left-1/2  flex justify-center'
                animate={{
                  opacity: sunAnimation ? 0 : 1,
                  x: '-50%',
                  y: mobileMode ? '-5%' : 0
                }}
                transition={{ duration: sunAnimation ? 1 : 0 }}
              >
                <img
                  src='../startMedia/wave.gif'
                  alt=''
                  className='w-full h-full object-cover'
                />
              </motion.div>
            )}

            {!mobileMode && (
              <motion.div
                className=' absolute bottom-[3%] right-[3%]  w-[80px] smallLaptop:w-[70px]'
                animate={{ opacity: sunAnimation ? 0 : 1 }}
                transition={{ duration: sunAnimation ? 1 : 0 }}
              >
                <img
                  src='../startMedia/green_island_logo.png'
                  alt='右下角Logo'
                  className='w-full object-contain'
                />
              </motion.div>
            )}

            <motion.div
              className=' absolute left-[3%] bottom-[3%] w-[25%] portraitPad:w-[70%] portraitPad:left-1/2 portraitBigPh:w-[85%] landscapePhone:left-[15%]'
              animate={{
                opacity: sunAnimation ? 0 : 1,
                x: mobileMode ? '-50%' : 0
              }}
              transition={{ duration: sunAnimation ? 1 : 0 }}
            >
              <img
                src='../startMedia/logo_all.png'
                alt='左下角logo'
                className='w-full object-contain'
              />
            </motion.div>
            <motion.div
              className=' absolute bottom-[6%] left-1/2 -translate-x-1/2  w-[120px] cursor-pointer landscapePad:w-[110px] smallLaptop:w-[100px] portraitPad:bottom-[18%] portraitBigPh:bottom-[20%] portraitBigPh:w-[90px] landscapePhone:w-[90px] landscapePhone:bottom-[1%]'
              onMouseEnter={() => setIsHover(true)}
              onMouseLeave={() => {
                setIsHover(false)
              }}
              animate={{ opacity: sunAnimation ? 0 : 1 }}
              transition={{ duration: sunAnimation ? 1 : 0 }}
            >
              <motion.div
                className='w-[50vw] text-center absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-[140%]  text-[17px] NotoSerifM text-white portraitBigPh:text-[16px] '
                variants={opacityVariants}
                initial='hide'
                animate='show'
              >
                您有一封來自綠島的信
              </motion.div>
              <motion.img
                src={
                  isHover
                    ? '../startMedia/letter_btn_hover.png'
                    : '../startMedia/letter_btn.png'
                }
                alt='信封'
                className='w-full object-contain'
                onClick={enterInfoPage}
              />
            </motion.div>
            <div className='w-full h-full'>
              <img
                src='../startMedia/sky_bg.png'
                alt='主背景'
                className='w-full h-full'
              />
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  )
}

export default Homepage
